export default __webpack_public_path__ + "static/uz-2e14f4729617cfe20e3376f94bc2af63.svg";